export const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length == 1 ? `0${hex}` : hex;
};

export function clamp(a: number, min = 0, max = 1) {
  return Math.min(max, Math.max(min, a));
}

export function lerp(x: number, y: number, a: number) {
  return x * (1 - a) + y * a;
}

export function inverseLerp(x: number, y: number, a: number) {
  return clamp((a - x) / (y - x));
}

export function range(x1: number, y1: number, x2: number, y2: number, a: number) {
  return lerp(x2, y2, inverseLerp(x1, y1, a));
}

export function toFixedNumber(num: number, digits: number) {
  return parseFloat(num.toFixed(digits));
}

export function rgbColorToHex(r: number, g: number, b: number) {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

export function rgbColorAToHex(r: number, g: number, b: number, a: number) {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}${componentToHex(a)}`;
}
